import { pipe } from "fp-ts/function";
import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
import { getModifier } from "../modifier-infra";
const nodesAccessor = (node) => node.nodes ?? [];
const nodesSetter = (nodes) => ({ nodes });
const getRootNode = (content) => ({
  id: "root",
  type: Node_Type.UNRECOGNIZED,
  nodes: content.nodes
});
const toRichContentModifier = (content) => function(modifier) {
  const self = { modifier };
  return {
    filter(predicate) {
      self.modifier = modifier.filter.bind(self.modifier)(predicate);
      self.modifier.set = this.set;
      self.modifier.filter = this.filter;
      return self.modifier;
    },
    set(setter) {
      const root = modifier.set.bind(self.modifier)(setter);
      return { ...content, nodes: root.nodes };
    }
  };
};
const modify = (content) => pipe(
  content,
  getRootNode,
  getModifier(nodesAccessor, nodesSetter),
  toRichContentModifier(content)
);
export {
  modify
};
//# sourceMappingURL=modify.js.map
